import { memoize } from 'lodash';
import { UploadFile } from 'antd';

type Validator = (
  rule: unknown,
  value: unknown,
  callback: (error?: string) => void
) => Promise<void>;

export const OFFICE_STUFF_FILE_TYPES = new Set([
  'text/csv',
  'text/tsv',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'image/jpg',
  'image/jpeg',
  'image/png',
]);

export const acceptedFileTypesValidator = memoize(
  (acceptedTypes: Set<string>) => (_: unknown, value: unknown) => {
    const files = (value || []) as UploadFile[];
    const firstInvalid = files.find((file) => !acceptedTypes.has(file.type!));

    return firstInvalid
      ? Promise.reject(
          `Unsupported file type '${firstInvalid.type || 'unknown'}'.`
        )
      : Promise.resolve();
  }
);

export const maxFileNumberValidator = memoize(
  (max: number, maxLabel: number) => (_: unknown, value: unknown) => {
    const files = (value || []) as UploadFile[];
    return files.length > max
      ? Promise.reject(
          `You can only upload ${maxLabel} files. Please remove a file to add a new file.`
        )
      : Promise.resolve();
  }
);

export const fileSizeValidator = memoize((sizeInMB: number): Validator => {
  return (_: unknown, value: unknown) => {
    const files = (value || []) as UploadFile[];
    const firstInvalid = files.find(
      (file) => file.size! / 1000 / 1000 > sizeInMB
    );

    return firstInvalid
      ? Promise.reject(
          `File exceeds maximum size. Please select a file smaller than ${sizeInMB} MB.`
        )
      : Promise.resolve();
  };
});
